export default __webpack_public_path__ + "static/media/cny-promo.3e89cf9b.webp";